// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__xnG6o","productName":"Table_productName__2GlQx"};